import { Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';

@Component({
    selector: 'app-imports-runner-bulk-add-modal',
    imports: [TranslateModule, ReactiveFormsModule],
    templateUrl: './imports-runner-bulk-add-modal.component.html',
    styleUrl: './imports-runner-bulk-add-modal.component.scss',
})
export class ImportsRunnerBulkAddModalComponent extends BaseModal {
    data: any;

    channelIdsForm = new UntypedFormGroup({
        channelIds: new UntypedFormControl(''),
    });

    onConfirmButtonClicked() {
        const inputChannelIds = this.channelIdsForm.get('channelIds')?.value?.trim();
        const parsedIds = inputChannelIds
            .split(/[,\n\r\s]+/)
            .map((id: string) => id.trim())
            .filter((id: string) => id.length > 0);

        this.closeModalInstance(parsedIds);
    }
}
